module.exports = __webpack_public_path__ + "img/oh-tannenbaum.0bd1de2d.jpeg";